/**
 * The only CRM catalog (single locale `nl`).
 *
 * Shared-file rule for parallel work: change this file ONLY with small
 * string replacements and add new keys under your own module section.
 */
export const dutchCrmMessages = {
  resources: {
    companies: {
      name: "Bedrijf |||| Bedrijven",
      forcedCaseName: "Bedrijf",
      fields: {
        name: "Bedrijfsnaam",
        address: "Adres",
        invoice_email: "E-mail factuurontvanger",
        description: "Opmerkingen",
        nb_contacts: "Contactpersonen",
        nb_sponsorings: "Sponsoringen",
        created_at: "Aangemaakt op",
        updated_at: "Gewijzigd op",
      },
      empty: {
        title: "Geen bedrijven gevonden",
        description: "Er zijn nog geen bedrijven ingevoerd.",
      },
      action: {
        add: "Bedrijf toevoegen",
        create: "Bedrijf aanmaken",
        delete: "Bedrijf verwijderen",
        edit: "Bedrijf bewerken",
        new: "Nieuw bedrijf",
      },
      list: {
        invoice_email: "E-mail factuur",
        error_loading: "De bedrijven konden niet worden geladen",
        no_results: "Geen bedrijven gevonden met de huidige zoekopdracht.",
      },
      helper: {
        invoice_email:
          "Meerdere adressen kunnen worden gescheiden door een komma.",
      },
      filters: {
        search: "Zoek op naam, adres of e-mail...",
      },
      not_filled: "Niet ingevuld",
      tabs: {
        contacts: "Contactpersonen",
        sponsorings: "Sponsoringen",
      },
      added_on: "Toegevoegd op %{date}",
      no_contacts: "Nog geen contactpersonen",
      no_sponsorings: "Nog geen sponsoringen",
      autocomplete: {
        create_error: "Het bedrijf kon niet worden aangemaakt",
        create_item: "%{item} aanmaken",
        create_label: "Begin met typen om een nieuw bedrijf aan te maken",
      },
      delete_confirm: {
        title: "Bedrijf %{name} verwijderen?",
        content:
          "De contactpersonen, sponsoringen en notities van dit bedrijf worden ook verwijderd. Dit kan niet ongedaan worden gemaakt.",
      },
      bulk_delete_confirm: {
        title:
          "%{smart_count} bedrijf verwijderen? |||| %{smart_count} bedrijven verwijderen?",
        content:
          "De contactpersonen, sponsoringen en notities van deze bedrijven worden ook verwijderd. Dit kan niet ongedaan worden gemaakt.",
      },
      deleted: "Bedrijf verwijderd |||| %{smart_count} bedrijven verwijderd",
      delete_error: "Het bedrijf kon niet worden verwijderd",
    },
    contacts: {
      name: "Contactpersoon |||| Contactpersonen",
      fields: {
        name: "Naam",
        first_name: "Voornaam",
        last_name: "Achternaam",
        company_id: "Bedrijf",
        email: "E-mail",
        created_at: "Toegevoegd op",
      },
      action: {
        add: "Contactpersoon toevoegen",
        edit: "Contactpersoon bewerken",
        new: "Nieuwe contactpersoon",
        show: "Contactpersoon bekijken",
      },
      empty: {
        title: "Geen contactpersonen gevonden",
        description: "Er zijn nog geen contactpersonen ingevoerd.",
      },
      list: {
        error_loading: "De contactpersonen konden niet worden geladen",
        no_results: "Geen contactpersonen gevonden met de huidige zoekterm.",
      },
      filters: {
        search: "Zoek op naam of e-mail...",
      },
    },
    sponsorings: {
      name: "Sponsoring |||| Sponsoringen",
      fields: {
        company_id: "Bedrijf",
        contract_type_id: "Contracttype",
        stage: "Fase",
        end_date: "Einddatum",
        description: "Opmerkingen",
        sales_id: "Behandelaar",
      },
      no_contract_type: "Nog geen contracttype",
      views: {
        label: "Overzicht",
        sponsorings: "Sponsoringen",
        ball: "Balsponsoren",
        leads: "Leads",
      },
      kinds: {
        ball: "Balsponsor",
      },
      action: {
        add: "Sponsoring toevoegen",
        create: "Sponsoring aanmaken",
        create_ball: "Balsponsor aanmaken",
        delete: "Sponsoring verwijderen",
        edit: "Sponsoring bewerken",
        new: "Nieuwe sponsoring",
        new_ball: "Nieuwe balsponsor",
        new_lead: "Nieuwe lead",
      },
      list: {
        no_results: "Geen sponsoringen gevonden met de huidige filters.",
        error_loading: "De sponsoringen konden niet worden geladen",
      },
      updated: "Sponsoring bijgewerkt",
      empty: {
        title: "Geen sponsoringen gevonden",
        description: "Voeg de eerste sponsoring of lead toe.",
        need_company:
          "Een sponsoring hoort altijd bij een bedrijf. Maak eerst een bedrijf aan.",
        create_company: "Bedrijf toevoegen",
      },
      invalid_date: "Ongeldige datum",
      expired: "Verlopen",
      ends_in:
        "Loopt over %{smart_count} dag af |||| Loopt over %{smart_count} dagen af",
      ends_today: "Loopt vandaag af",
      no_end_date: "Geen einddatum",
      no_owner: "Geen behandelaar",
      filters: {
        label: "Snelfilters",
        search: "Zoek op bedrijf of contracttype...",
        search_ball: "Zoek op bedrijf...",
        currently_active: "Momenteel actief",
        not_expired: "Niet verlopen",
        ending_soon: "Loopt binnenkort af",
        expired: "Verlopen",
        leads: "Leads",
        show_closed: "Toon gesloten",
        only_mine: "Alleen van mij",
      },
    },
    contract_types: {
      name: "Contracttype |||| Contracttypes",
      forcedCaseName: "Contracttype",
      fields: {
        name: "Naam",
        active: "Actief",
        sort_order: "Volgorde",
      },
      action: {
        new: "Nieuw contracttype",
      },
      filters: {
        search: "Zoek een contracttype...",
      },
      list: {
        error_loading: "De contracttypes konden niet worden geladen",
        no_results: "Geen contracttypes gevonden",
      },
      create: {
        title: "Nieuw contracttype aanmaken",
      },
      edit: {
        title: "%{name} bewerken",
      },
      inactive: "Inactief",
      hint: {
        sort_order:
          "De volgorde bepaalt hoe de contracttypes in de keuzelijsten staan: een laag getal komt eerst. Inactieve types kunnen niet aan nieuwe sponsoringen worden gekoppeld.",
      },
      in_use:
        "Dit contracttype wordt nog gebruikt door %{smart_count} sponsoring |||| Dit contracttype wordt nog gebruikt door %{smart_count} sponsoringen",
      in_use_delete:
        "In gebruik bij %{smart_count} sponsoring; zet het in plaats daarvan op inactief |||| In gebruik bij %{smart_count} sponsoringen; zet het in plaats daarvan op inactief",
    },
    notes: {
      name: "Notitie |||| Notities",
      fields: {
        text: "Notitie",
        date: "Datum",
        contact_id: "Contactpersoon",
        sponsoring_id: "Sponsoring",
      },
      action: {
        add: "Notitie toevoegen",
        delete: "Notitie verwijderen",
        edit: "Notitie bewerken",
        update: "Notitie bijwerken",
        add_this: "Deze notitie toevoegen",
      },
      sheet: {
        create: "Notitie aanmaken",
        create_for: "Notitie aanmaken voor %{name}",
        edit: "Notitie bewerken",
        edit_for: "Notitie bewerken voor %{name}",
      },
      deleted: "Notitie verwijderd",
      empty: "Nog geen notities",
      me: "Ik",
      list: {
        error_loading: "De notities konden niet worden geladen",
      },
      note_for_contact: "Notitie voor %{name}",
      added: "Notitie toegevoegd",
      inputs: {
        add_note: "Notitie toevoegen",
      },
      validation: {
        text_required: "Een notitie mag niet leeg zijn",
      },
    },
    sales: {
      name: "Gebruiker |||| Gebruikers",
      fields: {
        name: "Naam",
        first_name: "Voornaam",
        last_name: "Achternaam",
        email: "E-mail",
        administrator: "Beheerder",
        disabled: "Uitgeschakeld",
      },
      create: {
        error: "De gebruiker kon niet worden aangemaakt.",
        success: "Gebruiker aangemaakt.",
        title: "Nieuwe gebruiker aanmaken",
      },
      edit: {
        error: "Er is iets misgegaan. Probeer het opnieuw.",
        record_not_found: "Gebruiker niet gevonden",
        success: "Gebruiker bijgewerkt",
        title: "%{name} bewerken",
      },
      action: {
        new: "Nieuwe gebruiker",
        reset_password: "Wachtwoord opnieuw instellen",
        row_actions: "Acties voor gebruiker",
      },
      filters: {
        search: "Zoek een gebruiker...",
      },
      list: {
        error_loading: "De gebruikers konden niet worden geladen",
        no_results: "Geen gebruikers gevonden",
      },
      temporary_password: {
        title: "Tijdelijk wachtwoord voor %{name}",
        description:
          "Geef dit persoonlijk aan de gebruiker. Het wordt maar één keer getoond; de gebruiker kan het wijzigen onder Mijn profiel.",
        label: "Tijdelijk wachtwoord",
      },
      reset_password: {
        confirm_title: "Wachtwoord van %{name} opnieuw instellen?",
        confirm_content:
          "Een nieuw tijdelijk wachtwoord vervangt het huidige direct. De gebruiker kan niet meer inloggen met het oude wachtwoord.",
        error: "Het wachtwoord kon niet opnieuw worden ingesteld.",
      },
      hint: {
        no_delete:
          "Gebruikers kunnen niet worden verwijderd. Schakel een account uit om de toegang in te trekken; de notities en sponsoringen blijven op naam staan.",
        self_protection:
          "Je kunt je eigen beheerdersrechten niet intrekken en je eigen account niet uitschakelen.",
      },
    },
  },
  crm: {
    auth: {
      sign_in_failed: "Inloggen is mislukt.",
      wrong_credentials: "Onjuist e-mailadres of wachtwoord",
      account_disabled: "Dit account is uitgeschakeld",
      forgot_password_hint:
        "Wachtwoord vergeten? Vraag een beheerder om een nieuw wachtwoord.",
    },
    common: {
      details: "Details",
      retry: "Opnieuw proberen",
      copied: "Gekopieerd!",
      copy: "Kopiëren",
      loading: "Laden...",
    },
    errors: {
      user_not_found: "Gebruiker niet gevonden",
      wrong_current_password: "Het huidige wachtwoord is onjuist",
      password_too_short: "Het nieuwe wachtwoord moet minstens 8 tekens hebben",
      cannot_disable_self:
        "Je kunt je eigen account niet uitschakelen of je beheerdersrechten intrekken",
      users_not_deletable:
        "Gebruikers kunnen niet worden verwijderd; schakel het account uit",
      contract_type_in_use:
        "Dit contracttype wordt nog gebruikt door een sponsoring en kan niet worden verwijderd",
    },
    dashboard: {
      error: "De gegevens konden niet worden geladen.",
      expiring_sponsorings: "Aflopende sponsoringen",
      expiring: {
        group_expired: "Verlopen",
        group_within_30: "Binnen 30 dagen",
        group_within_90: "Binnen 90 dagen",
        empty: "Er loopt niets af in de komende 90 dagen.",
        badge_expired: "Verlopen",
        badge_today: "Vandaag",
        badge_days: "%{smart_count} dag |||| %{smart_count} dagen",
      },
      greeting: {
        morning: "Goedemorgen, %{name}",
        afternoon: "Goedemiddag, %{name}",
        evening: "Goedenavond, %{name}",
      },
      search_placeholder: "Zoek een bedrijf...",
      search_label: "Bedrijf zoeken",
      new_lead: "Nieuwe lead",
      funnel: {
        title: "Leads in de funnel",
        add_lead: "lead",
        move_to: "Verplaats naar…",
        move_lead: "Verplaats deze lead naar een andere fase",
      },
      expired: {
        title: "Verlopen",
        empty: "Geen verlopen sponsoringen.",
      },
      ending_soon: {
        title: "Loopt af binnen 90 dagen",
        within: "≤ %{days} dagen",
      },
      stats: {
        active: "Actieve sponsoringen",
        expired: "Verlopen",
        within_30: "Binnen 30 dagen",
        within_90: "Binnen 90 dagen",
        without_end_date: "Zonder einddatum",
        open_leads: "Open leads",
      },
      view_all: "Alles bekijken",
      view_all_count: "Alle %{count}",
      empty: {
        title: "Welkom bij Sliedrecht Sport Sponsoring",
        description:
          "Er zijn nog geen bedrijven ingevoerd. Begin met het toevoegen van een bedrijf; daarna kun je er contactpersonen en sponsoringen aan koppelen.",
        add_company: "Bedrijf toevoegen",
      },
    },
    settings: {
      title: "Instellingen",
      app_title: "Titel van de applicatie",
      sponsorings: {
        stages: "Fasen",
        stages_help:
          "Pas de namen van de fasen aan. Een fase die nog door een sponsoring wordt gebruikt kun je niet verwijderen.",
        statuses: "Rol van de fasen",
        statuses_help:
          "Geef per fase aan of die een lead is (nog in gesprek), als lopende sponsoring telt of gesloten is.",
        active_statuses: "Actieve sponsoring",
        closed_statuses: "Gesloten",
        board_stage: "Lead",
      },
      reset_defaults: "Standaardwaarden herstellen",
      save_error: "De instellingen konden niet worden opgeslagen",
      saved: "Instellingen opgeslagen",
      validation: {
        duplicate: "Dubbele fasen: %{items}",
        in_use:
          "Deze fasen worden nog door sponsoringen gebruikt en kunnen niet worden verwijderd: %{items}",
        validating: "Controleren…",
      },
    },
    navigation: {
      label: "Navigatie",
      admin: "Beheer",
      role_admin: "Beheerder",
      role_member: "Commissielid",
    },
    profile: {
      title: "Mijn profiel",
      password: {
        change: "Wachtwoord wijzigen",
        description: "Kies een nieuw wachtwoord van minstens 8 tekens.",
        current: "Huidig wachtwoord",
        new: "Nieuw wachtwoord",
        confirm: "Bevestig nieuw wachtwoord",
        mismatch: "De wachtwoorden komen niet overeen",
        too_short: "Minstens 8 tekens",
        changed: "Je wachtwoord is gewijzigd",
        error:
          "Het wachtwoord kon niet worden gewijzigd. Controleer je huidige wachtwoord en probeer het opnieuw.",
      },
      record_not_found: "Gebruiker niet gevonden",
      updated: "Je profiel is bijgewerkt",
      update_error: "Er is iets misgegaan. Probeer het opnieuw",
    },
  },
} as const;

export type CrmMessages = typeof dutchCrmMessages;
